export default "__VITE_ASSET__ac7b81bb__$_?react__"